import { useState, useEffect } from 'react';
import { hot } from 'react-hot-loader';
import { useModal } from 'react-simple-modal-provider';
import { useSelector, useDispatch } from 'react-redux';
import { useEagerConnect, useActiveWeb3React } from './hooks/index';
import getNftContract from './hooks/getNftContract';
//import { utils } from 'ethers';
import * as A from './store/actions';
import * as S from './store/selectors';



function AppConfig() {
  const dispatch = useDispatch();
  const isSoldOut = useSelector(S.nft.getSoldOut);
  const { open: openAlertModal } = useModal('AlertModal');

  const triedEager = useEagerConnect();
  const context = useActiveWeb3React();
  const { chainId, /*account, active,*/ library } = context;

  //const [isInit, setInit] = useState(false);
  const [isUpdating, setUpdating] = useState(false);
  //const [lastChainId, setLastChainId] = useState(0);
  const onBlockHandler = async (blockNumber) => {
    if (isUpdating) return;
    setUpdating(true);

    dispatch(A.provider.setBlockNumber(blockNumber));
    try {
      const constract = getNftContract(chainId, library);
      if (constract) {
        if (!isSoldOut) {
          const totalSupply = await constract.totalSupply();
          dispatch(A.nft.setTotalSupply(totalSupply.toNumber()));
        } else {
          dispatch(A.nft.setTotalSupply(7777));
        }

        /*if (!isInit && chainId === 4 || lastChainId !== chainId) {
          const timePresale = await constract.TIMESTAMP_PRESALE();
          dispatch(A.nft.setTimstampPresale(timePresale.toNumber()));

          const timePresaleEnd = await constract.TIMESTAMP_RAFFLE();
          dispatch(A.nft.setTimstampPresaleEnd(timePresaleEnd.toNumber()));

          const timeRaffleEnd = await constract.TIMESTAMP_RAFFLE_END();
          dispatch(A.nft.setTimstampRaffleEnd(timeRaffleEnd.toNumber()));

          const timeSale = await constract.TIMESTAMP_SALE();
          dispatch(A.nft.setTimstampSale(timeSale.toNumber()));


          //const pricePresale = await constract.PRICE_PRESALE();
          //dispatch(A.nft.setPricePresale(utils.formatEther(pricePresale)));

          //const priceSale = await constract.PRICE_SALE();
          //dispatch(A.nft.setPriceSale(utils.formatEther(priceSale)));

          setInit(true);
        }

        if (lastChainId !== chainId) {
          setLastChainId(chainId);
        }*/
      }
    } catch (error) {
      //console.error(error);
      //dispatch(A.nft.clear());
    }
    setUpdating(false);
  }

  useEffect(() => {
    if (library) {
      library.on('block', onBlockHandler);
    }
  }, [chainId, library]);

  useEffect(() => {
    dispatch(A.provider.setChainId(chainId));
  }, [chainId]);

  useEffect(() => {
    //setTimeout(openAlertModal, 1500);

    const now = Math.trunc(new Date().getTime() / 1000);
    dispatch(A.nft.setTimstamp(now));
    if (library) {
      library.getBlockNumber()
        .then((blockNumber) => onBlockHandler(blockNumber))
        .catch(() => null);
    }

    const intervalId = setInterval(() => {
      dispatch(A.nft.setTimstamp(now));
    }, 1000);
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return (null);
};

export default hot(module)(AppConfig);
